import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["rectSize", "legendCellSize", "space", "startDate", "endDate", "rectProps", "rectRender", "legendRender", "value", "weekLabels", "monthLabels", "panelColors", "style"];
import React, { useEffect, useMemo, useState } from 'react';
import { LabelsWeek } from './LabelsWeek';
import { LabelsMonth } from './LabelsMonth';
import { Rect } from './Rect';
import { formatData, getDateToString, existColor, numberSort, isValidDate, oneDayTime } from './utils';
import Legend from './Legend';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function SVG(props) {
  var _ref = props || {},
      _ref$rectSize = _ref.rectSize,
      rectSize = _ref$rectSize === void 0 ? 11 : _ref$rectSize,
      _ref$legendCellSize = _ref.legendCellSize,
      legendCellSize = _ref$legendCellSize === void 0 ? 11 : _ref$legendCellSize,
      _ref$space = _ref.space,
      space = _ref$space === void 0 ? 2 : _ref$space,
      _ref$startDate = _ref.startDate,
      startDate = _ref$startDate === void 0 ? new Date() : _ref$startDate,
      endDate = _ref.endDate,
      rectProps = _ref.rectProps,
      rectRender = _ref.rectRender,
      legendRender = _ref.legendRender,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? [] : _ref$value,
      _ref$weekLabels = _ref.weekLabels,
      weekLabels = _ref$weekLabels === void 0 ? ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'] : _ref$weekLabels,
      _ref$monthLabels = _ref.monthLabels,
      monthLabels = _ref$monthLabels === void 0 ? ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'] : _ref$monthLabels,
      _ref$panelColors = _ref.panelColors,
      panelColors = _ref$panelColors === void 0 ? {
    0: 'var(--rhm-rect, #EBEDF0)',
    8: '#7BC96F',
    4: '#C6E48B',
    12: '#239A3B',
    32: '#196127'
  } : _ref$panelColors,
      style = _ref.style,
      other = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      gridNum = _useState2[0],
      setGridNum = _useState2[1];

  var _useState3 = useState(!!weekLabels ? 28 : 5),
      _useState4 = _slicedToArray(_useState3, 2),
      leftPad = _useState4[0],
      setLeftPad = _useState4[1];

  var _useState5 = useState(!!monthLabels ? 20 : 5),
      _useState6 = _slicedToArray(_useState5, 2),
      topPad = _useState6[0],
      setTopPad = _useState6[1];

  var svgRef = /*#__PURE__*/React.createRef();
  var nums = useMemo(function () {
    return numberSort(Object.keys(panelColors).map(function (item) {
      return parseInt(item, 10);
    }));
  }, [panelColors]);
  var data = useMemo(function () {
    return formatData(value);
  }, [value]);
  useEffect(function () {
    return setLeftPad(!!weekLabels ? 28 : 5);
  }, [weekLabels]);
  useEffect(function () {
    if (svgRef.current) {
      var width = svgRef.current.clientWidth - leftPad || 0;
      setGridNum(Math.floor(width / (rectSize + space)) || 0);
    }
  }, [rectSize, svgRef, space, leftPad]);
  useEffect(function () {
    setTopPad(!!monthLabels ? 20 : 5);
  }, [monthLabels]);
  var initStartDate = useMemo(function () {
    if (isValidDate(startDate)) {
      return !startDate.getDay() ? startDate : new Date(startDate.getTime() - startDate.getDay() * oneDayTime);
    } else {
      var newDate = new Date();
      return new Date(newDate.getTime() - newDate.getDay() * oneDayTime);
    }
  }, [startDate]);
  var styl = {
    color: 'var(--rhm-text-color, #24292e)',
    userSelect: 'none',
    display: 'block',
    fontSize: 10
  };
  return /*#__PURE__*/_jsxs("svg", _extends({
    ref: svgRef,
    style: _extends({}, styl, style)
  }, other, {
    children: [legendCellSize !== 0 && /*#__PURE__*/_jsx(Legend, {
      legendRender: legendRender,
      panelColors: panelColors,
      rectSize: rectSize,
      legendCellSize: legendCellSize,
      leftPad: leftPad,
      topPad: topPad,
      space: space
    }), /*#__PURE__*/_jsx(LabelsWeek, {
      weekLabels: weekLabels,
      rectSize: rectSize,
      space: space,
      topPad: topPad
    }), /*#__PURE__*/_jsx(LabelsMonth, {
      monthLabels: monthLabels,
      rectSize: rectSize,
      space: space,
      leftPad: leftPad,
      colNum: gridNum,
      startDate: initStartDate
    }), /*#__PURE__*/_jsx("g", {
      transform: "translate(" + leftPad + ", " + topPad + ")",
      children: gridNum > 0 && _toConsumableArray(Array(gridNum)).map(function (_, idx) {
        return /*#__PURE__*/_jsx("g", {
          "data-column": idx,
          children: _toConsumableArray(Array(7)).map(function (_, cidx) {
            var currentDate = new Date(initStartDate.getTime() + oneDayTime * (idx * 7 + cidx));
            var date = getDateToString(currentDate);

            var dataProps = _extends({}, data[date], {
              date: date,
              row: cidx,
              column: idx,
              index: idx * 7 + cidx
            });

            var dayProps = _extends({}, rectProps, {
              key: cidx,
              fill: 'var(--rhm-rect, #EBEDF0)',
              width: rectSize,
              height: rectSize,
              x: idx * (rectSize + space),
              y: (rectSize + space) * cidx,
              render: rectRender,
              value: dataProps
            });

            if (endDate instanceof Date && currentDate.getTime() > endDate.getTime()) {
              return null;
            }

            if (date && data[date] && panelColors && Object.keys(panelColors).length > 0) {
              dayProps.fill = existColor(data[date].count || 0, nums, panelColors);
            } else if (panelColors && panelColors[0]) {
              dayProps.fill = panelColors[0];
            }

            return /*#__PURE__*/_jsx(Rect, _extends({}, dayProps, {
              value: dataProps,
              "data-date": date,
              "data-index": dataProps.index,
              "data-row": dataProps.row,
              "data-column": dataProps.column
            }));
          })
        }, idx);
      })
    })]
  }));
}